import React, { useMemo } from 'react';
import { StepInfo, Wizard } from 'shared/components/Wizard';
import { ClosingTaskWizardLayout } from 'sellDirect/components/closingDash/ClosingTaskWizardLayout';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { Box, Text } from '@opendoor/bricks/core';
import { DigitalCheckout } from 'sellDirect/components/closingDash/closing/DigitalCheckout';
import { getHubSellingRoute } from 'shared/helpers/routes';
import { useHistory } from 'platform/HistoryProvider';
import { ClosedOffer, UnderContractOffer } from 'sellDirect/OfferContext';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

export interface ClosingWizardProps {
  offer: UnderContractOffer | ClosedOffer;
  closingTasks: ClosingTasks;
}

/**
 * Wizard to allow users to do digital checkout
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const ClosingWizard: React.FC<ClosingWizardProps> = ({ offer, closingTasks }) => {
  const { addressUUID } = useQualificationContext();
  const { history, goBack } = useHistory();
  const initialLocation = useMemo(() => history.location, [history]);
  const taskSubmitted = offer?.closingExperience.digitalCheckout?.submittedAt;
  const steps: StepInfo[] = [
    {
      title: 'Finalize closing details',
      // eslint-disable-next-line react/display-name
      content: () => (
        <ClosingTaskWizardLayout>
          <Box my={9}>
            <DigitalCheckout offer={offer} closingTasks={closingTasks} />
          </Box>
        </ClosingTaskWizardLayout>
      ),
      confirmOnClose: taskSubmitted
        ? undefined
        : {
            cancelText: 'Finish answering questions',
            confirmText: 'Close without saving',
            content: (
              <Text mb="8">
                If you leave before you finish answering all questions, it won’t save your progress.
              </Text>
            ),
            title: 'Are you sure you want to stop?',
          },
    },
  ];

  return (
    <Wizard
      steps={steps}
      title="Finalizing closing details"
      onClose={() =>
        goBack({
          before: initialLocation,
          fallbackLocation: getHubSellingRoute(),
          addressUUID,
        })
      }
    />
  );
};
